module.exports = __webpack_public_path__ + "img/img_82837_0_41.aba8934a.png";